window.am = window.am || {};

window.am.groupFormat = new function () {

    var that = this;

    that.init = function () {
        var targetFields = document.querySelectorAll('[data-group-format]');

        if (targetFields == null || targetFields.length == 0) {
            return;
        }

        for (let i = 0; i < targetFields.length; i++) {

            let targetField = targetFields[i];

            var groupData = targetField.getAttribute('data-group-data');

            if (groupData == null || groupData == '') {
                groupData = 3;
            }

            var splitChar = targetField.getAttribute('data-split-char');

            if (splitChar == null || splitChar == '') {
                splitChar = ' ';
            }

            var maxLength = targetField.getAttribute('data-max-length');

            if (maxLength == null || maxLength == '')
            {
                maxLength = 0;
            }

            if (targetField.value.length > 0) {
                targetField.value = splitValue(targetField.value, groupData, splitChar);
            }

            targetField.addEventListener('input', function (e)
            {
                var oldValue = this.value;

                if (maxLength > 0)
                {
                    var valueWithoutSplitchars = oldValue.replace(new RegExp(splitChar, 'g'), '');

                    if (valueWithoutSplitchars.length > maxLength)
                    {
                        var difference = valueWithoutSplitchars.length - maxLength; 
                        this.value = oldValue.substr(0, this.value.length - difference);

                        return;
                    }
                }

                var cursorPosition = getCaretPosition(this);
                var formattedValue = splitValue(oldValue, groupData, splitChar);
                this.value = formattedValue;
                var spaceAdded = formattedValue.length > oldValue.length;

                /* data is null if backspace is pressed. this prevents that the cursor stays right next to the space.
                 * Workaround because its not possible in input event to get the pressed key for special characters like "Backspace" */
                if (spaceAdded && e.data != null) {
                    cursorPosition++;
                }

                setCaretPosition(this, cursorPosition);
            });
        }
    }

    function splitValue(text, groupData, splitChar) {
        text = getStringWithoutSpaces(text);

        var split = groupData;
        var chunk = [];

        for (var i = 0, len = text.length; i < len; i += split) {
            chunk.push(text.substr(i, split));
        }

        return chunk.join(splitChar);
    }

    function getStringWithoutSpaces(text) {
        return text.replace(/[\W\s\._\-]+/g, '');
    }

    /*
     ** Returns the caret (cursor) position of the specified text field.
     ** Return value range is 0-oField.value.length.
     ** From: http://stackoverflow.com/a/2897229/496992
     */
    function getCaretPosition(oField) {
        // Initialize
        var iCaretPos = 0;

        // IE Support
        if (document.selection) {

            // Set focus on the element
            oField.focus();

            // To get cursor position, get empty selection range
            var oSel = document.selection.createRange();

            // Move selection start to 0 position
            oSel.moveStart('character', -oField.value.length);

            // The caret position is selection length
            iCaretPos = oSel.text.length;
        } // Firefox support
        else if (oField.selectionStart || oField.selectionStart == '0')
            iCaretPos = oField.selectionStart;

        // Return results
        return iCaretPos;
    }

    /* From: http://stackoverflow.com/a/512542/496992 */
    function setCaretPosition(elem, caretPos) {
        if (elem != null) {
            if (elem.createTextRange) {
                var range = elem.createTextRange();
                range.move('character', caretPos);
                range.select();
            } else {
                if (elem.selectionStart) {
                    elem.focus();
                    elem.setSelectionRange(caretPos, caretPos);
                }
                else {
                    elem.focus();
                }
            }
        }
    }
}

window.am.groupFormat.init();